export default function TermsOfServicePage() {
    return (
        <div className="prose prose-invert prose-sm max-w-3xl mx-auto">
            <h1 className="text-2xl font-bold text-slate-100">Terms of Service</h1>
            <p className="text-xs text-slate-500">Last updated: March 6, 2026</p>

            <h2>1. Acceptance of Terms</h2>
            <p>
                By creating an account or using DebtBound ("the Service"), you agree
                to be bound by these Terms of Service. If you do not agree, do not
                use the Service.
            </p>

            <h2>2. Description of Service</h2>
            <p>
                DebtBound is a consensual financial domination contract management
                platform. It provides tools for consenting adults to create, track,
                and manage simulated financial contracts in the context of BDSM
                power exchange dynamics.
            </p>
            <p>
                <strong>DebtBound is not a financial institution.</strong> It does
                not process payments, extend credit, collect debts, or provide
                financial services of any kind. All monetary amounts displayed within
                the platform are for record-keeping and gamification purposes only.
                Actual transfers of money, if any, occur entirely outside the platform
                and are solely between the parties involved.
            </p>

            <h2>3. Eligibility</h2>
            <ul>
                <li>You must be at least 18 years of age.</li>
                <li>You must have the legal capacity to enter into agreements.</li>
                <li>You must provide a valid email address.</li>
            </ul>

            <h2>4. Consent &amp; Safe Practice</h2>
            <p>
                All activities on DebtBound must be <strong>safe, sane, and
                consensual (SSC)</strong> or follow <strong>risk-aware consensual
                kink (RACK)</strong> principles. By using the Service, you affirm:
            </p>
            <ul>
                <li>
                    All contracts you enter are voluntary and consensual.
                </li>
                <li>
                    You understand the terms of any contract before signing.
                </li>
                <li>
                    You acknowledge that "hardcore mode" contracts limit your ability
                    to abandon the contract or require consent for changes, and you
                    accept these terms knowingly.
                </li>
                <li>
                    Ownership relationships (where a sub requests a dom as their
                    owner) are consensual and can be released by either party at any
                    time.
                </li>
                <li>
                    Exclusive contracts (which prevent a sub from signing additional
                    contracts) require the sub to have an approved owner relationship
                    first.
                </li>
            </ul>

            <h2>5. User Accounts</h2>
            <ul>
                <li>You are responsible for maintaining the security of your account.</li>
                <li>You may not share your account credentials with others.</li>
                <li>You must provide accurate information when creating your account.</li>
                <li>
                    You may link third-party accounts (Google, Discord, GitHub,
                    Twitter/X, Microsoft) for authentication or display purposes.
                </li>
            </ul>

            <h2>6. Roles &amp; Contracts</h2>
            <h3>Roles</h3>
            <p>
                Users select a role (Dominant, Submissive, or Switch) that determines
                the features available to them. Dominants can create contract
                templates and manage subs. Submissives can sign contracts and request
                ownership. Switches can act in both roles.
            </p>

            <h3>Contract Types</h3>
            <ul>
                <li>
                    <strong>Standard contracts:</strong> Either party can close or
                    abandon the contract at any time.
                </li>
                <li>
                    <strong>Exclusive contracts:</strong> Prevent the sub from
                    signing additional contracts while active. Require the sub to
                    have an owner.
                </li>
                <li>
                    <strong>Hardcore contracts:</strong> The sub cannot abandon the
                    contract unless they first revoke hardcore mode. Changes to
                    contract terms do not require sub consent.
                </li>
            </ul>

            <h3>Ownership</h3>
            <p>
                Subs and switches may request ownership from a dom. The dom must
                approve the request. Either party may release the ownership at any
                time. Ownership is required to enter exclusive contracts.
            </p>

            <h2>7. Prohibited Conduct</h2>
            <p>You agree not to:</p>
            <ul>
                <li>Use the Service for any illegal purpose</li>
                <li>Harass, threaten, or abuse other users</li>
                <li>Create accounts with false or misleading information</li>
                <li>Attempt to access other users' accounts</li>
                <li>Interfere with or disrupt the Service</li>
                <li>Use the Service to facilitate non-consensual activities</li>
                <li>Scrape, data-mine, or programmatically access the Service without authorization</li>
                <li>Use the platform to facilitate actual illegal debt collection or financial fraud</li>
            </ul>

            <h2>8. Content &amp; Public Information</h2>
            <p>
                You are responsible for the content you post, including profile
                information, contract titles, pillory posts, and review text. We
                reserve the right to remove content that violates these terms or is
                reported as abusive.
            </p>
            <p>
                Information you choose to make public (public profile, public
                contracts, Wall of Shame entries, Pillory posts) will be visible to
                other users.
            </p>

            <h2>9. Disclaimer of Warranties</h2>
            <p>
                The Service is provided "as is" and "as available" without warranties
                of any kind, express or implied. We do not guarantee that the Service
                will be uninterrupted, error-free, or secure.
            </p>

            <h2>10. Limitation of Liability</h2>
            <p>
                DebtBound, its operators, and contributors shall not be liable for
                any indirect, incidental, special, consequential, or punitive damages
                arising from your use of the Service, including but not limited to:
            </p>
            <ul>
                <li>Financial losses arising from activities conducted outside the platform</li>
                <li>Emotional distress from contract activities</li>
                <li>Disputes between users</li>
                <li>Data loss or security breaches</li>
            </ul>

            <h2>11. Termination</h2>
            <p>
                We reserve the right to suspend or terminate your account at any time
                for violations of these Terms. You may also request deletion of your
                account at any time. Termination does not relieve you of obligations
                under active contracts between you and other users.
            </p>

            <h2>12. Modifications</h2>
            <p>
                We may update these Terms from time to time. We will provide notice
                of material changes via in-app notification or email. Continued use
                of the Service after changes take effect constitutes acceptance of the
                revised Terms.
            </p>

            <h2>13. Governing Principles</h2>
            <p>
                These Terms shall be interpreted in good faith and in the spirit of
                consensual power exchange. Disputes between users should first be
                resolved through direct communication between the parties.
            </p>

            <h2>14. Contact</h2>
            <p>
                For questions about these Terms of Service, please contact the
                platform administrator.
            </p>
        </div>
    );
}
